module.exports = __webpack_public_path__ + "static/media/w_queen.2c023bb0.png";